export enum Route {
    CreateQualityStatement = "quality-statement/create",
    GetTemplates = "quality-statement/templates",
    Commit = "quality-statement/commit",
}
